import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkspaceIdentityService = ( createDecorator('IWorkspaceIdentityService'));
export { IWorkspaceIdentityService };
